import { Box, CircularProgress, styled } from '@mui/material';
import { FC } from 'react';

const Container = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
});

interface LoaderProps {
  color?: string;
}

export const Loader: FC<LoaderProps> = ({ color }) => {
  return (
    <Container>
      <CircularProgress sx={{ color }} />
    </Container>
  );
};
